import types from "../types";
import { getUserInfo, authLogout } from "@saas/server-api/src/index";
import i18n from "@saas/i18n/src";
import cookie from "@saas/components/src/plugins/cookie";
import { Message } from "element-ui";
import {
  setToken,
  removeToken,
  setRefreshToken,
  removeRefreshToken,
} from "@saas/server-api/src/plugins/auth";
import router from "@/router/index";
const userInfo = {
  state: {
    profile: null,
  },
  mutations: {
    [types.CHANGE_PROFILE](state, { profile }) {
      state.profile = profile;
      if (profile.language) {
        i18n.locale = profile.language;
      }
      // storage.set(STORAGE_KEY.AUTHED, !!profile.user)
    },
  },
  actions: {
    getProfile({ commit, dispatch }) {
      getUserInfo().then((res) => {
        let data = {};
        if (res.code === 1 && res.data) {
          data = res.data;
          if (!data.avatar) {
            data.avatar =
              "https://cdn.moguocdn.com/cdn/static/images/default_avatar.png";
          }
        }
        commit(types.CHANGE_PROFILE, {
          profile: data,
        });
        dispatch("user/getUserPermissions");
      });
    },
    clearProfile({ commit }) {
      authLogout().then((res) => {
        if (res.code === 1) {
          // let domain = window.location.hostname;
          // let index = domain.indexOf(".");
          // if (index !== -1) {
          //   domain = domain.slice(index);
          // }
          // cookie.delCookie("accessToken", domain);
          removeToken();
          removeRefreshToken();
          commit(types.CHANGE_PROFILE, {
            profile: {},
          });
          // window.location.href = location.origin;
          router.push({ name: "Home" });
          if (window.isElectron) {
            window.location.reload();
          }
          // window.location.href = `${process.env.VUE_APP_ADMIN_URL}/login?return_url=${window.location.href}`;
        } else {
          Message.error(res.message);
        }
      });
    },
  },
};
export default userInfo;
